import React, { useEffect, useState } from "react";
import axios from "axios";
// import layout from "../../assets/img/leinholder/layout.svg";
import layout from "../../assets/img/leinholder/layout.png";
import aboutBackground from "../../assets/img/aboutus/aboutBackground.svg";
import "../leinHolder/leinHolder.css";
import Loader from "../../Loader";
import "../../index.css";
import selectCorrectUrls from "../../selectCorrectUrls";

const Leinholder = () => {
  const [responsiveStatus, setResponsiveStatus] = useState(false);
  const [loading, setLoading] = useState(true);
  const [requiredErrors, setRequiredErrors] = useState({
    policyNumber: false,
    vinLast5: false,
  });

  useEffect(() => {
    const mediaQueries = {
      isSmallMobile: window.matchMedia("(max-width: 400px)"),
      isMobile: window.matchMedia("(max-width: 768px)"),
      isTablet: window.matchMedia("(max-width: 900px)"),
    };

    const updateItemsPerPage = () => {
      if (mediaQueries.isSmallMobile.matches) {
        setResponsiveStatus(true);
      } else if (mediaQueries.isMobile.matches) {
        setResponsiveStatus(true);
      } else if (mediaQueries.isTablet.matches) {
        setResponsiveStatus(true);
      } else {
        setResponsiveStatus(false);
      }
    };

    // Initial run
    updateItemsPerPage();

    // Event listeners
    Object.values(mediaQueries).forEach((mq) =>
      mq.addEventListener("change", updateItemsPerPage)
    );

    // Cleanup
    return () => {
      Object.values(mediaQueries).forEach((mq) =>
        mq.removeEventListener("change", updateItemsPerPage)
      );
    };
  }, []);

  const [policyNumber, setPolicyNumber] = useState("");
  const [vinLast5, setVinLast5] = useState("");
  const [showSearchResults, setShowSearchResults] = useState(false);
  const [result, setResult] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");

  const getInputClass = (value, error) => {
    if (error) return "form-control border-danger";
    if (value.trim() !== "") return "form-control border-success";
    return "form-control";
  };

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 2000);
  }, []);

  const handleSearch = async () => {
    const newErrors = {
      policyNumber: policyNumber.trim() === "",
      vinLast5: vinLast5.trim() === "",
    };
    setRequiredErrors(newErrors);
    if (!newErrors.policyNumber && !newErrors.vinLast5) {
      setLoading(true);
      try {
        const formData = new URLSearchParams();
        formData.append("lienPolicyNumber", policyNumber);
        formData.append("leinVinNumber", vinLast5);
        formData.append("requestType", "fetch");
        formData.append("verifyLeinHolder", "true");

        const response = await axios.post(
          `${selectCorrectUrls().insuredPortal}/insurednew/insured/lien/jsond`,
          formData,
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
          }
        );

        if (response?.data?.error) {
          setErrorMessage(response.data.error);
        } else {
          setResult(response.data);
        }
      } catch (error) {
        console.error("API Error:", error);
        setErrorMessage("Search Results not Found!");
      } finally {
        setShowSearchResults(true);
        setLoading(false);
      }
    }
  };

  const formatPhoneNumber = (phone) => {
    if (!phone || phone.length !== 10) return "N/A";

    return `(${phone.slice(0, 3)})-${phone.slice(3, 6)}-${phone.slice(6)}`;
  };

  return (
    <>
      {/* {loading && <Loader />} */}
      {/* {!loading && ( */}
      <div className="become-agent-bg1">
        {/* Modal Component */}

        <div
          style={{
            textAlign: "center",
            padding: responsiveStatus ? "15px 15px" : "15px 0",
          }}
        >
          {/* Decorative shapes */}

          <h3
            className="leinholder-partner"
            style={{ fontWeight: 600, fontSize: "20px" }}
          >
            Seamless Service
          </h3>
          <div className="become-agent-underline" />
          <h1 className="become-agent-title">Lienholder Verification</h1>
          <p className="become-agent-desc1">
            At UAIC, we streamline the lienholder verification process to ensure
            accuracy and efficiency. Whether you're a lienholder verifying
            policy details or need updates on coverage, our intuitive platform
            provides the information you need quickly and securely.{" "}
          </p>
          <div>
            <img className="img-fluid" src={layout} alt="layout" />
          </div>
        </div>

        {/* LeinHolder Form */}
        <div
          className={`p-8 ${
            responsiveStatus
              ? "leinholder-form-wrapperM"
              : "leinholder-form-wrapper"
          }`}
        >
          <div
            className={`flex-1 bg-green-leinholder-100 rounded-lg shadow-sm mt-1`}
            style={{ marginBottom: "6rem" }}
          >
            <h2 className="dtl-heading">
              Search for Lienholder Verification Details
            </h2>
            <div className="">
              <div className="details-input-wrap">
                <div className="input-wrap">
                  <label className="">Enter Policy Number</label>
                  <input
                    value={policyNumber}
                    onChange={(e) => setPolicyNumber(e.target.value)}
                    type="text"
                    placeholder="Policy Number"
                    className={getInputClass(
                      policyNumber,
                      requiredErrors.policyNumber
                    )}
                    style={styles.inputStyle}
                    onKeyDown={(e) => {
                      setErrorMessage("");
                      setShowSearchResults("");

                      const isLetterOrNumber = /^[0-9]$/.test(e.key); // Only digits
                      const allowedControlKeys = [
                        "Backspace",
                        "Tab",
                        "ArrowLeft",
                        "ArrowRight",
                        "Delete",
                      ];

                      const isPasteCombo =
                        (e.ctrlKey || e.metaKey) && e.key.toLowerCase() === "v";

                      if (
                        !isLetterOrNumber &&
                        !allowedControlKeys.includes(e.key) &&
                        !isPasteCombo
                      ) {
                        e.preventDefault(); // Block everything else
                      }
                    }}
                    onPaste={(e) => {
                      const pasted = e.clipboardData
                        .getData("text")
                        .replace(/\D/g, ""); // Digits only
                      e.preventDefault();
                      setPolicyNumber(pasted);
                    }}
                  />
                </div>
                <div className="input-wrap">
                  <label className="">Last 5 Digits of VIN Number</label>
                  <input
                    value={vinLast5}
                    onChange={(e) => setVinLast5(e.target.value)}
                    maxLength={5}
                    type="text"
                    placeholder="xxxxx"
                    className={getInputClass(vinLast5, requiredErrors.vinLast5)}
                    style={styles.inputStyle}
                    onKeyDown={(e) => {
                      setErrorMessage("");
                      setShowSearchResults("");

                      const isLetterOrNumber = /^[0-9]$/.test(e.key);
                      const allowedControlKeys = [
                        "Backspace",
                        "Tab",
                        "ArrowLeft",
                        "ArrowRight",
                        "Delete",
                      ];

                      const isPasteCombo =
                        (e.ctrlKey || e.metaKey) && e.key.toLowerCase() === "v";

                      if (
                        e.key === "Enter" &&
                        vinLast5.length === 5 &&
                        policyNumber !== ""
                      ) {
                        handleSearch();
                      }

                      if (
                        !isLetterOrNumber &&
                        !allowedControlKeys.includes(e.key) &&
                        !isPasteCombo
                      ) {
                        e.preventDefault(); // Still block all other unwanted keys
                      }
                    }}
                    onPaste={(e) => {
                      // Optional: further restrict what is allowed to be pasted
                      const pasted = e.clipboardData
                        .getData("text")
                        .replace(/\D/g, "")
                        .slice(0, 5);
                      e.preventDefault();
                      setVinLast5(pasted);
                    }}
                  />
                </div>
                <div className="btn-cover">
                  {/* onClick={() => setshowSearchResults(true)} */}
                  <button
                    onClick={handleSearch}
                    className="btn btn-primary-login"
                    style={{
                      height: "39px",
                      textAlign: "center",
                      padding: "10px 16px 10px 16px",
                      borderRadius: "4px",
                      width: "100px",
                    }}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        handleSearch();
                      }
                    }}
                  >
                    Search
                  </button>
                </div>
              </div>
            </div>

            {showSearchResults ? (
              result && errorMessage === "" ? (
                <div
                  className="w-full bg-white rounded-lg shadow-sm mt-5"
                  style={{ padding: "20px" }}
                >
                  <h2 className="dtl-heading">Search Results</h2>
                  <p style={{ fontWeight: "600" }}>
                    Policy is{" "}
                    <span
                      style={{
                        color:
                          result.LISTAT === "A"
                            ? "green"
                            : result.LISTAT === "X"
                            ? "#a30000"
                            : result.LISTAT === "L"
                            ? "#a30000"
                            : result.LISTAT === "C"
                            ? "Cancellation Notice"
                            : "#a30000",
                        fontWeight: "600",
                      }}
                    >
                      {result.LISTAT === "A"
                        ? "Active"
                        : result.LISTAT === "X"
                        ? "Expired"
                        : result.LISTAT === "L"
                        ? "Cancelled"
                        : result.LISTAT === "C"
                        ? "Cancellation Notice"
                        : "N/A"}
                    </span>{" "}
                    with policy Period {result.LIEFFDATE || "N/A"} to{" "}
                    {result.LIEXPDATE || "N/A"}
                  </p>
                  <div className="table-responsive">
                    <table className="table">
                      <thead>
                        <tr>
                          <th
                            style={{
                              color: "white",
                              backgroundColor:
                                result.LISTAT === "A"
                                  ? "green"
                                  : result.LISTAT === "X"
                                  ? "#a30000"
                                  : result.LISTAT === "L"
                                  ? "#a30000"
                                  : result.LISTAT === "C"
                                  ? "Cancellation Notice"
                                  : "#a30000",
                            }}
                          >
                            Policy#: {policyNumber || ""}
                          </th>
                          <th
                            style={{
                              color: "white",
                              backgroundColor:
                                result.LISTAT === "A"
                                  ? "green"
                                  : result.LISTAT === "X"
                                  ? "#a30000"
                                  : result.LISTAT === "L"
                                  ? "#a30000"
                                  : result.LISTAT === "C"
                                  ? "Cancellation Notice"
                                  : "#a30000",
                            }}
                          >
                            Policy Effective Date: {result.LIEFFDATE || "N/A"}
                          </th>
                          <th
                            style={{
                              color: "white",
                              backgroundColor:
                                result.LISTAT === "A"
                                  ? "green"
                                  : result.LISTAT === "X"
                                  ? "#a30000"
                                  : result.LISTAT === "L"
                                  ? "#a30000"
                                  : result.LISTAT === "C"
                                  ? "Cancellation Notice"
                                  : "#a30000",
                            }}
                          >
                            Policy Expiration Date: {result.LIEXPDATE || "N/A"}
                          </th>
                        </tr>
                      </thead>
                      <tbody style={{ backgroundColor: "#ffffff" }}>
                        <tr>
                          <td>
                            <p>
                              <strong>Policy Status:</strong>{" "}
                              {result.LISTAT === "A"
                                ? "Active"
                                : result.LISTAT === "X"
                                ? "Expired"
                                : result.LISTAT === "L"
                                ? "Cancelled"
                                : result.LISTAT === "C"
                                ? "Cancellation Notice"
                                : "N/A"}
                            </p>
                            <p>
                              <strong>Excluded driver exists:</strong>{" "}
                              {result.LIEXCDRV === "Y" ? "Yes" : "No"}
                            </p>
                            <p>
                              <strong>Vehicle Year:</strong>{" "}
                              {result.LIVYEAR || "N/A"}
                            </p>
                            <p>
                              <strong>Vin Number:</strong>{" "}
                              {result.vinfull || ""}
                            </p>
                            <p>
                              <strong>Comprehensive deductible:</strong>{" "}
                              {result.LIVPHYDED || "N/A"}
                            </p>
                            <p>
                              <strong>Lienholder Name:</strong>{" "}
                              {result.LILNAME || "N/A"}
                            </p>
                            <p>
                              <strong>Lienholder Address:</strong>{" "}
                              {result.LILADDRESS || "N/A"},{" "}
                              {result.LILCITY || "N/A"},{" "}
                              {result.LILSTATE || "N/A"},{" "}
                              {result.LILZIPCD || "N/A"}
                            </p>
                          </td>
                          <td>
                            <p>
                              <strong>Due Date:</strong>{" "}
                              {result.LIDUEDTE || "N/A"}
                            </p>
                            <p>
                              <strong>Vehicle Make:</strong>{" "}
                              {result.LIVMAKE || "N/A"}
                            </p>
                            <p>
                              <strong>Vehicle Add date:</strong>{" "}
                              {result.LIVEHADDDT || "N/A"}
                            </p>
                            <p>
                              <strong>Collision Deductible:</strong>{" "}
                              {result.LIVPHYDED || "N/A"}
                            </p>
                          </td>
                          <td>
                            <p>
                              <strong>Vehicle Model:</strong>{" "}
                              {result.LIVMODEL || "N/A"}
                            </p>

                            <p>
                              <strong>Agency Name:</strong>{" "}
                              {result.AGMNAM || "N/A"}
                            </p>

                            <p>
                              <strong>Agency Address:</strong>{" "}
                              {result.AGMADD || "N/A"}, {result.AGMST || "N/A"},{" "}
                              {result.AGMZIP || "N/A"}
                            </p>

                            <p>
                              <strong>Agency Phone:</strong>{" "}
                              {formatPhoneNumber(result.AGMTEL) || "N/A"}
                            </p>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  {/* <div className="row mt-2">
                      <div className="col-md-4">
                        <label>Policy Number</label>
                        <input
                          className="form-control"
                          type="text"
                          value={policyNumber || ""}
                          readOnly
                        />
                      </div>
                      <div className="col-md-4">
                        <label>Last 5 Digits of Vin #</label>
                        <input
                          className="form-control"
                          type="text"
                          value={result.vinfull || ""}
                          readOnly
                        />
                      </div>
                      <div className="col-md-4">
                        <label>Agent Name</label>
                        <input
                          className="form-control"
                          type="text"
                          value={result.AGMNAM || ""}
                          readOnly
                        />
                      </div>
                      <div className="col-md-4">
                        <label>Agent Phone</label>
                        <input
                          className="form-control"
                          type="text"
                          value={result.AGMTEL || ""}
                          readOnly
                        />
                      </div>
                      <div className="col-md-8">
                        <label>Agent Address</label>
                        <input
                          className="form-control"
                          type="text"
                          value={result.AGMADD || ""}
                          readOnly
                        />
                      </div>
                    </div> */}
                </div>
              ) : (
                <center>
                  {" "}
                  <p
                    className="text-danger mt-3"
                    style={{ fontWeight: "bold" }}
                  >
                    {errorMessage}
                  </p>
                </center>
              )
            ) : null}
          </div>
        </div>
      </div>
      {/* )} */}
    </>
  );
};
const styles = {
  container: {
    // display: "flex",
    // flexWrap: "wrap",
    // width: "100%",
    minHeight: "400px",
    fontFamily: "Arial, sans-serif",
  },
  becomeAgentBG: {
    textAlign: "center",
  },
  leinHolderImage: {
    height: "377px",
    width: "566px",
    // minHeight:'80vh',
    overflow: "hidden",
    backgroundImage: `url(${layout})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    marginTop: "-40px",
  },
  form: {
    display: "flex",
  },
  modalHeaderBar: {
    width: "100%",
    background: "#f4f9ff",
    borderBottom: "1px solid #e3e3e3",
    borderTopLeftRadius: "20px",
    borderTopRightRadius: "20px",
    minHeight: "60px",
    position: "relative",
    zIndex: 2,
  },
  modalHeading: {
    fontWeight: 600,
    fontSize: "20px",
    color: "#000000",
  },
  closeButton: {
    fontSize: "1rem",
    cursor: "pointer",
    opacity: 1,
  },
  sidebar: {
    width: "220px",
    backgroundColor: "#fff",
    padding: "32px 0 0 0",
    borderRight: "1px solid #e3e3e3",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
  },
  sidebarItem: {
    width: "100%",
    padding: "16px 32px",
    cursor: "pointer",
    fontWeight: 500,
    fontSize: "18px",
    color: "#222",
    background: "transparent",
    border: "none",
    outline: "none",
    textAlign: "left",
    transition: "background 0.2s, color 0.2s",
  },
  sidebarItemActive: {
    background: "#e3f0ff",
    color: "#1976d2",
    fontWeight: 700,
  },
  sidebarTextActive: {
    color: "#1976d2",
    fontWeight: 700,
  },
  content: {
    flex: 1,
    // padding: '40px 40px 32px 40px',
    position: "relative",
    background: "#fff",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
  },
  modalOverlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 1000,
  },
  inputStyle: {
    width: "100%",
    height: "39px",
    borderRadius: "4px",
    paddingTop: "14px",
    paddingRight: "10px",
    paddingBottom: "14px",
    paddingLeft: "10px",
    borderWidth: "1px",
    borderStyle: "solid", // You likely want to define a style
    borderColor: "#A39B9B", // optional: define color if needed
  },
  inputStyle1: {
    width: "100%",
    height: "44px",
    borderRadius: "4px",
    borderWidth: "1px",
    borderStyle: "solid",
    borderColor: "#A39B9B",
    paddingTop: "14px",
    paddingRight: "10px",
    paddingBottom: "14px",
    paddingLeft: "10px",
  },
  inputStyle2: {
    width: "100%",
    height: "44px",
    borderRadius: "4px",
    borderWidth: "1px",
    borderStyle: "solid",
    borderColor: "#A39B9B",
    paddingTop: "14px",
    paddingRight: "10px",
    paddingBottom: "14px",
    paddingLeft: "10px",
    marginLeft: "34px",
  },
  button: {
    fontWeight: 500,
    fontSize: "18px",
    minWidth: "500px !important",
  },
};

export default Leinholder;
